<template>

    <div class="field">
        <label class="label" v-if="props.etichetta">{{ props.etichetta }}</label>
        <div class="field has-addons">
            <div class="control" v-if="!(props.solaLettura)">
                <input class="input" :class="classeAllineamento()" type="text" v-model="valoreCondizionato" @change="modificaValore()">
            </div>
            <div class="control" title="Campo non editabile" v-if="props.solaLettura">
                <input class="input" :class="classeAllineamento()" type="text" v-model="valoreCondizionato" readonly>
            </div>
            <div class="control" v-if="props.tipoBottone!=''">
                <button class="button is-primary" @click="bAzione">{{ testoBottone }}</button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, ref } from "vue";
    import { trovaNumeroPreventivo, trovaNumeroDico } from "@/code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        valore: {
            type: Number,
            default: null
        },
        identificativo: {
            type: String,
            default: ''
        },
        etichetta: {
            type: String,
            default: null
        },
        tipo: {
            type: String,   // Intero, Decimale
            default: 'Intero'
        },
        decimali: {         // Numero di decimali
            type: Number,
            default: 0
        },
        allineamento: {     // Sinistra, Destra, Centro
            type: String,
            default: 'Destra'
        },
        formato: {          // Numero = numero con separazione migliaia; Flat = senza separazione; Percentuale = numero con % finale
            type: String,
            default: 'Numero'
        },
        tipoBottone: {          // numeroPreventivo, numeroDico, aliquota...
            type: String,
            default: ''
        },
        solaLettura: {
            type: Boolean,
            default: false
        }
    });
    const emit = defineEmits(['valoreCambiato', 'bottoneClick']);

    // VARIABILI DEL COMPONENTE
    const valoreCondizionato = ref(props.valore);
    const testoBottone = ref(null);

    // SETUP DEL COMPONENTE
    condizionaValore();

    // FUNZIONI DEL COMPONENTE
    function bAzione() {
        switch (props.tipoBottone) {
            case 'numeroPreventivo':
                valoreCondizionato.value = parseInt(trovaNumeroPreventivo());
                emit('valoreCambiato', valoreCondizionato.value, props.identificativo);
                break;
            case 'numeroDico':
                valoreCondizionato.value = parseInt(trovaNumeroDico());
                emit('valoreCambiato', valoreCondizionato.value, props.identificativo);
                break;
            case 'aliquota':
                emit('bottoneClick', valoreCondizionato.value, props.identificativo);
        }
    }

    function condizionaValore() {
        switch (props.formato) {
            case 'Numero':
                if ( valoreCondizionato.value==null || valoreCondizionato.value==0) {
                    valoreCondizionato.value = '';
                } else {
                    valoreCondizionato.value = valoreCondizionato.value.toLocaleString("it-IT", {
                    notation: "standard",
                    minimumFractionDigits: props.decimali,
                    maximumFractionDigits: props.decimali});
                }
                break;
            case 'Flat':
                if ( valoreCondizionato.value==null || valoreCondizionato.value==0) {
                    valoreCondizionato.value = '';
                }
                break;
            case 'Percentuale':
                // valoreCondizionato.value = (valoreCondizionato.value*100).toString()+'%';
                valoreCondizionato.value = valoreCondizionato.value*100;
                valoreCondizionato.value = valoreCondizionato.value.toString()+' %';
                break;
        }
        // Prepara il bottone
        switch (props.tipoBottone) {
            case 'numeroPreventivo':
            case 'numeroDico':
                testoBottone.value = '+';
                break;
            case 'aliquota':
                testoBottone.value = '%';
                break;
            default:
                testoBottone.value = '';
        }
    }

    function modificaValore() {
        // Prepara il valore per la successiva restituzione tramite emit
        if (valoreCondizionato.value != '') {
            switch(props.tipo) {
                case 'Intero':
                    valoreCondizionato.value = parseInt(valoreCondizionato.value);
                    if (props.formato == 'Percentuale') {
                        valoreCondizionato.value = valoreCondizionato.value/100;

                    }
                    break;
                case 'Decimale':
                    valoreCondizionato.value = parseFloat( valoreCondizionato.value.replace('.', '').replace('.', '').replace(/,/, '.') );
                    break;
                // case 'Percentuale':
                //     valoreCondizionato.value = parseInt(parseFloat(valoreCondizionato.value.replace('%', ''))/100);
                //     break;
            }
        } else {
            valoreCondizionato.value = null;
        }
        emit('valoreCambiato', valoreCondizionato.value, props.identificativo);
        condizionaValore();
    }

    function classeAllineamento() {
        switch (props.allineamento) {
            case 'Sinistra':
                return 'has-text-left';
            case 'Destra':
                return 'has-text-right';
            case 'Centro':
                return 'has-text-centered';
            default:
                return 'has-text-right';
        }
    }
</script>